import React from 'react';

import { PriceSummary } from '@/components/SchedulingForm';
import { useRateDisplay } from '@/hooks/useRateDisplay';
import { RateDisplayType, toCreditsPerHour } from '@/utils/rateDisplay';

import type { AccountLinkedStepProps } from '../../types';
import { useStyles } from './AccountLinkedStep.styles';

export function AccountLinkedStep({
  expert,
  duration,
  hourlyRate,
  onContinue,
}: AccountLinkedStepProps): JSX.Element {
  const s = useStyles();
  const displayType = useRateDisplay();
  const showUSD = displayType === RateDisplayType.USD;

  return (
    <>
      <div className={s.formContent}>
        {/* Success icon */}
        <div className={s.iconContainer}>
          <svg
            className={s.icon}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        {/* Title and subtitle */}
        <h3 className={s.title}>Phone Number Linked!</h3>
        <p className={s.subtitle}>
          Your phone number has been added to your account. You can now log in with either method.
        </p>

        {/* Price summary */}
        <PriceSummary
          duration={duration}
          pricing={
            showUSD
              ? { type: 'dollars', hourlyRate }
              : { type: 'credits', creditRate: toCreditsPerHour(expert.creditRate) }
          }
          showChargeNote
        />
      </div>

      {/* Footer with continue button */}
      <div className={s.footer}>
        <button type="button" className={s.continueButton} onClick={onContinue}>
          Continue to Payment
        </button>
      </div>
    </>
  );
}

export default AccountLinkedStep;
